// @flow
import React from 'react';

type Props = {
  title: string,
  titleClass?: string
};

function h3Title({ title, titleClass }: Props) {
  return <h3 className={titleClass}>{title}</h3>;
}

export default h3Title;
